import Vue from "vue";
import VueRouter from "vue-router";
import { productType } from "config/config";

/**
 * 重写路由的push方法
 */
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}



// 页面异常
const NotFoundComponent = () => import(/* webpackChunkName: "" */ "components/errorPage/404.vue");

const Login = () => import(/* webpackChunkName: "login" */ "views/login");
const Home = () => import(/* webpackChunkName: "home" */ "views/home");
const HomePage = () => import(/* webpackChunkName: "home" */ "views/home/home-page");

// 注册
const Register = () => import(/* webpackChunkName: "login" */ "views/register");
// 找回密码
const RecoverPassword = () => import(/* webpackChunkName: "login" */ "views/recover-password");
// 购买
const Purchase = () => import(/* webpackChunkName: "purchase" */ "views/purchase");
const ProductDetails = () => import(/* webpackChunkName: "purchase" */ "views/purchase/product-details");
const PurchaseStep1 = () => import(/* webpackChunkName: "purchase" */ "views/purchase/step1");
const PurchaseStep2 = () => import(/* webpackChunkName: "purchase" */ "views/purchase/step2");
const PurchaseStep3 = () => import(/* webpackChunkName: "purchase" */ "views/purchase/step3");
// 绑卡
const BindingCard = () => import(/* webpackChunkName: "login" */ "views/binding-card");

// 我的任务
const MyTask = () => import(/* webpackChunkName: "myTask" */ "views/my-task");
const MyTaskList = () => import(/* webpackChunkName: "myTask" */ "views/my-task/list");
const MyTaskDetail = () => import(/* webpackChunkName: "myTask" */ "views/my-task/detail");

// 同步课程
const SynchronousCourses = () => import(/* webpackChunkName: "synchronousCourses" */ "views/synchronous-courses");

// 播放页面
const PlayPage = () => import(/* webpackChunkName: "synchronousCourses" */ "views/play-page");

// 直播课堂
const LiveCourse = () => import(/* webpackChunkName: "liveCourse" */ "views/live-course");

// 专题课程
const TopicClasses = () => import(/* webpackChunkName: "topicClasses" */ "views/topic-classes");

// 试卷库
const Examination = () => import(/* webpackChunkName: "Examination" */ "views/examination");

// 资源详情页 专题课程 + 试卷库
const ResourceDetail = () => import(/* webpackChunkName: "topicClasses" */ "views/resource-detail");

// 个人中心
const PersonalCenter = () => import(/* webpackChunkName: "personalCenter" */ "views/personal-center");
const BasicInfo = () => import(/* webpackChunkName: "personalCenter" */ "views/personal-center/basic-info");
const BookVersion = () => import(/* webpackChunkName: "personalCenter" */ "views/personal-center/book-version");
const ChangePwd = () => import(/* webpackChunkName: "personalCenter" */ "views/personal-center/change-pwd");
const Collection = () => import(/* webpackChunkName: "personalCenter" */ "views/personal-center/collection");
const HistoryRecord = () => import(/* webpackChunkName: "personalCenter" */ "views/personal-center/history-record");
const LearningTrack = () => import(/* webpackChunkName: "personalCenter" */ "views/personal-center/learning-track");
const Feedback = () => import(/* webpackChunkName: "personalCenter" */ "views/personal-center/feedback");

// 其他静态页面
const OtherPages = () => import(/* webpackChunkName: "otherPages" */ "views/other-pages");
const AboutUs = () => import(/* webpackChunkName: "otherPages" */ "views/other-pages/about-us");
const ContactUs = () => import(/* webpackChunkName: "otherPages" */ "views/other-pages/contact-us");
const Instructions = () => import(/* webpackChunkName: "otherPages" */ "views/other-pages/instructions");
const UserAgreement = () => import(/* webpackChunkName: "otherPages" */ "views/other-pages/user-agreement");
const PrivacyPolicy = () => import(/* webpackChunkName: "otherPages" */ "views/other-pages/privacy-policy");
const TeacherInfo = () => import(/* webpackChunkName: "otherPages" */ "views/teacher-info");


Vue.use(VueRouter);

let routes = [
  {
    path: "/login",
    name: "Login",
    redirect: '/home-page',
    component: Login,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/',
    redirect: '/home-page'
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    children: [
      {
        path: '/register',
        name: 'Register',
        component: Register,
        meta: {
          title: '注册',
        },
      },
      {
        path: '/recover-password',
        name: 'RecoverPassword',
        component: RecoverPassword,
        meta: {
          title: '找回密码',
        },
      },
      {
        path: '/purchase',
        name: 'Purchase',
        component: Purchase,
        redirect: '/purchase/product-details',
        meta: {
          title: '购买',
        },
        children: [
          {
            path: '/purchase/product-details',
            name: 'ProductDetails',
            component: ProductDetails,
            meta: {
              title: '学习卡购买',
            },
          },
          {
            path: '/purchase/step1',
            name: 'PurchaseStep1',
            component: PurchaseStep1,
            meta: {
              title: '订单',
            },
          },
          {
            path: '/purchase/step2',
            name: 'PurchaseStep2',
            component: PurchaseStep2,
            meta: {
              title: '支付',
            },
          },
          {
            path: '/purchase/step3',
            name: 'PurchaseStep3',
            component: PurchaseStep3,
            meta: {
              title: '完成支付',
            },
          }
          
        ]
      },
      {
        path: '/binding-card',
        name: 'BindingCard',
        component: BindingCard,
        meta: {
          title: '绑卡',
          needToken: true
        },
      },
      {
        path: '/home-page',
        name: 'HomePage',
        component: HomePage,
        meta: {
          title: '首页',
          module: 'HOME',
        },
      },
      {
        path: '/synchronous-courses',
        name: 'SynchronousCourses',
        component: SynchronousCourses,
        meta: {
          title: '同步课程',
          module: 'SYNCHRONOUS_COURSES',
        },
      },
      {
        path: '/play',
        name: 'PlayPage',
        component: PlayPage,
        meta: {
          title: '视频播放',
          module: '',
        },
      },
      {
        path: '/topic-classes',
        name: 'TopicClasses',
        component: TopicClasses,
        meta: {
          title: '专题课程',
          module: '',
        },
      },
      {
        path: '/resource-detail',
        name: 'ResourceDetail',
        component: ResourceDetail,
        meta: {
          title: '专题课程',
          module: '',
        },
      },
      {
        path: '/examination',
        name: 'Examination',
        component: Examination,
        meta: {
          title: '试卷库',
          module: '',
        },
      },
      {
        path: '/live-course',
        name: 'LiveCourse',
        component: LiveCourse,
        meta: {
          title: '直播课堂',
          module: 'LIVE_COURSE',
          needToken: false
        },
      },
      {
        path: '/my-task',
        name: 'MyTask',
        component: MyTask,
        meta: {
          title: '我的任务',
          module: 'STUDENT_MY_TASK',
          needToken: true
        },
        children: [
          {
            path: '/my-task/list',
            name: 'MyTaskList',
            component: MyTaskList,
            meta: {
              title: '任务列表',
              module: 'STUDENT_MY_TASK',
              needToken: true
            },
          },
          {
            path: '/my-task/detail',
            name: 'MyTaskDetail',
            component: MyTaskDetail,
            meta: {
              title: '任务详情',
              module: 'STUDENT_MY_TASK',
              needToken: true
            },
          },
        ]
        
      },
      {
        path: '/personal-center',
        name: 'PersonalCenter',
        component: PersonalCenter,
        meta: {
          title: '个人中心',
          module: 'STUDENT_PERSONAL_CENTER',
          needToken: true
        },
        children: [
          {
            path: '/personal-center/basic-info',
            name: 'BasicInfo',
            component: BasicInfo,
            meta: {
              title: '基本资料',
              needToken: true
            }
          },
          {
            path: '/personal-center/book-version',
            name: 'BookVersion',
            component: BookVersion,
            meta: {
              title: '教材设置',
              needToken: true
            },
          },
          {
            path: '/personal-center/change-pwd',
            name: 'ChangePwd',
            component: ChangePwd,
            meta: {
              title: '修改密码',
              needToken: true
            }
          },
          {
            path: '/personal-center/collection',
            name: 'Collection',
            component: Collection,
            meta: {
              title: '我的收藏',
              needToken: true
            },
          },
          {
            path: '/personal-center/history-record',
            name: 'HistoryRecord',
            component: HistoryRecord,
            meta: {
              title: '观看记录',
              needToken: true
            }
          },
          {
            path: '/personal-center/learning-track',
            name: 'LearningTrack',
            component: LearningTrack,
            meta: {
              title: '学习轨迹',
              needToken: true
            },
          },
          {
            path: '/personal-center/feedback',
            name: 'Feedback',
            component: Feedback,
            meta: {
              title: '意见反馈',
              needToken: true
            },
          }
        ]
      },
      {
        path: '/other-pages',
        name: 'OtherPages',
        component: OtherPages,
        meta: {
          title: '',
        },
        children: [
          {
            path: '/other-pages/about-us',
            name: 'AboutUs',
            component: AboutUs,
            meta: {
              title: '关于我们'
            }
          },
          {
            path: '/other-pages/contact-us',
            name: 'ContactUs',
            component: ContactUs,
            meta: {
              title: '联系我们'
            }
          },
          {
            path: '/other-pages/instructions',
            name: 'Instructions',
            component: Instructions,
            meta: {
              title: '使用说明'
            }
          },
          {
            path: '/other-pages/user-agreement',
            name: 'UserAgreement',
            component: UserAgreement,
            meta: {
              title: '用户协议'
            }
          },
          {
            path: '/other-pages/privacy-policy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy,
            meta: {
              title: '隐私政策'
            }
          },
        ]
      },
      {
        path: '/teacher-info',
        name: 'TeacherInfo',
        component: TeacherInfo,
        meta: {
          title: '教师信息公示',
          module: 'TeacherInfo',
          needToken: false
        }
      }
    ]
  },
];

let _productType = 1;
if(isNaN(productType)) {
  _productType = 1;
}else {
  _productType = Number(productType);
}
let _not1 = [
  { 
    path: '*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  }
];
let _not2 = [
  { 
    path: '*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  },
  { 
    path: '/my-task*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  }
];
let _not3 = [
  { 
    path: '*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  },
  { 
    path: '/live-course*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  },
  { 
    path: '/synchronous-courses*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  },
  { 
    path: '/binding-card*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  },
  { 
    path: '/purchase*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  },
  { 
    path: '/personal-center/book-version*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  },
  { 
    path: '/personal-center/collection*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  },
  { 
    path: '/personal-center/history-record*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  },
  { 
    path: '/register*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  },
  { 
    path: '/play*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  },
  { 
    path: '/other-pages/instructions*', 
    component: NotFoundComponent,
    meta: {
      title: 'Not Found'
    }
  },
];
if(_productType === 2) {
  routes.unshift(..._not2);
}else if(_productType === 3) {
  routes.unshift(..._not3);
}else if(_productType === 1) {
  routes.unshift(..._not1);
}

const router = new VueRouter({
  linkActiveClass: 'router-active',
  routes
});

export default router;
